/* ---------------------------------------------------------
   DATA / CONFIG
--------------------------------------------------------- */
const PRODUCT_COLORS = {
  tshirt: [
    {key:'black',     name:'Black',      hex:'#1a1a1a'},
    {key:'white',     name:'White',      hex:'#ffffff'},
    {key:'charcoal',  name:'Charcoal',   hex:'#4b4b4d'},
    {key:'navy',      name:'Navy',       hex:'#1b2a4a'},
    {key:'blue',      name:'Blue',       hex:'#2255aa'},
    {key:'bblue',     name:'Baby Blue',  hex:'#7fb8e0'},
    {key:'red',       name:'Red',        hex:'#b32020'},
    {key:'darkgreen', name:'Dark Green', hex:'#2f4f34'},
    {key:'olive',     name:'Olive',      hex:'#6b6b3a'},
    {key:'yellow',    name:'Yellow',     hex:'#e8c320'},
    {key:'beige',     name:'Beige',      hex:'#e8dcc3'},
    {key:'cream',     name:'Cream',      hex:'#f2e9d8'},
  ],
  hoodie: [
    {key:'black',       name:'Black',        hex:'#1a1a1a'},
    {key:'white',       name:'White',        hex:'#ffffff'},
    {key:'charcoal',    name:'Charcoal',     hex:'#4b4b4d'},
    {key:'grey',        name:'Grey',         hex:'#9a9a9e'},
    {key:'navyblue',    name:'Navy Blue',    hex:'#1b2a4a'},
    {key:'blue',        name:'Blue',         hex:'#2255aa'},
    {key:'red',         name:'Red',          hex:'#b32020'},
    {key:'darkred',     name:'Dark Red',     hex:'#7a1f1f'},
    {key:'darkgreen',   name:'Dark Green',   hex:'#2f4f34'},
    {key:'yellow',      name:'Yellow',       hex:'#e8c320'},
    {key:'beige',       name:'Beige',        hex:'#e8dcc3'},
    {key:'lightpink',   name:'Light Pink',   hex:'#f3c9d6'},
    {key:'lightpurple', name:'Light Purple', hex:'#cbb8e8'},
  ],
};

/* real Shopify product handles this customizer sells — used to look up
   real variant IDs (for Add to Cart) and to know the base price per item */
const PRODUCT_HANDLES = { tshirt: 't-shirt', hoodie: 'hoodie' };

const PRODUCT_IMAGE_DIMS = {
  tshirt: {w:900, h:812},
  hoodie: {w:900, h:954},
};

/* print zone as % of the image box, calibrated to the actual garment photos */
/* each view has a "full" print zone and a smaller "chest logo" zone
   anchored to its top-right corner (per the reference photo) */
const PRINT_ZONES = {
  tshirt: {
    front: { full:{x:29, y:30, w:45, h:54}, small:{x:58, y:30, w:15, h:17} },
    back:  { full:{x:32, y:20, w:36, h:36}, small:{x:56, y:20, w:12, h:11} },
  },
  hoodie: {
    front: { full:{x:32, y:40, w:36, h:30}, small:{x:56, y:40, w:12, h:9} },
    back:  { full:{x:30, y:24, w:40, h:38}, small:{x:57, y:24, w:13, h:12} },
  },
};
/* the print-location list shown to the user: each entry is one distinct
   print job (its own design slot + its own price toward "number of prints") */
const LOCATIONS = [
  {key:'front',     label:'Front',      view:'front', size:'full'},
  {key:'frontlogo', label:'Front Logo', view:'front', size:'small'},
  {key:'back',      label:'Back',       view:'back',  size:'full'},
];
/* the two photo views available for the stage/thumbnails */
const PHOTO_VIEWS = [
  {key:'front', label:'Front'},
  {key:'back', label:'Back'},
];

const SIZES = ['XS','S','M','L','XL','2XL','3XL'];

/* measurements in cm, from the official B3 size-guide artwork */
const SIZE_CHARTS = {
  tshirt: [
    {size:'XS', w:46, h:67},
    {size:'S',  w:51, h:69},
    {size:'M',  w:54, h:71},
    {size:'L',  w:57, h:73},
    {size:'XL', w:60, h:75},
    {size:'2XL',w:63, h:77},
    {size:'3XL',w:66, h:79},
  ],
  hoodie: [
    {size:'XS', w:50, h:66},
    {size:'S',  w:53, h:68},
    {size:'M',  w:56, h:70},
    {size:'L',  w:59, h:72},
    {size:'XL', w:62, h:74},
  ],
};
const PRINT_METHODS = [
  {key:'print',      label:'Printing',   icon:'🖨️', hint:'Works for any design with any number of colors — faster and cheaper.'},
  {key:'embroidery', label:'Embroidery', icon:'🧵', hint:'Best for simple logos/text — richer texture and quality, at a higher price.'},
];

/* fallback pricing shown before the real product prices load — the actual
   charge always comes from the live Shopify variant price. This is the
   BLANK garment price — every print or embroidery location is charged on
   top of it via EXTRA_PRINT_PRICE below, with no "first one free" */
const BASE_PRICE = { tshirt: 10, hoodie: 20 };
const EXTRA_PRINT_PRICE = { print: 5, embroidery: 8 }; // charged per design location (front/back/logo), every location, no free first one

/* real Shopify variant id for the hidden "Extra Print" add-on product that
   makes the checkout total actually match what the price summary shows —
   a plain garment variant only has ONE fixed price, so every print/
   embroidery location is added to the cart as its own small line item
   (quantity = number of locations) instead of being silently dropped at
   checkout */
const ADDON_VARIANTS = {
  extraPrint: { print: 49594899300611, embroidery: 49594899333379 }, // "Extra Print" product, per design location
};

function imagePath(product, colorKey, view){
  return `${window.B3_ASSET_BASE}${product}-${colorKey}-${view}.jpg`;
}

/* ---------------------------------------------------------
   EMBROIDERY LOOK
   A custom pixel filter that simulates satin-stitch embroidery on any
   artwork with transparency (uploaded PNG/SVG, or rasterized text):

     1. a chamfer distance transform of the alpha mask gives, for every
        opaque pixel, its distance to the nearest edge
     2. the gradient of that distance field points "across" the local
        shape width — exactly the direction real satin stitches run
        (crossing a letter stroke, sweeping across a fill) — so the
        thread-ridge shading follows the CONTOUR of the artwork instead
        of a single fixed diagonal
     3. a thin band near the edge gets darkened in a dashed cadence to
        read as a running-stitch outline
     4. combined with Posterize (fabric's built-in filter) to flatten
        gradients/anti-aliasing into a handful of flat "thread colors"

   Not real embroidery digitizing (that's dedicated software), but a much
   closer live approximation than a plain diagonal overlay.
--------------------------------------------------------- */
/* force the plain 2D-canvas filter backend (not WebGL) so our custom pixel
   filter below always gets real imageData to work with, and every filter
   in a chain runs through the same predictable pipeline */
fabric.filterBackend = new fabric.Canvas2dFilterBackend();

fabric.Image.filters.EmbroideryTexture = fabric.util.createClass(fabric.Image.filters.BaseFilter, {
  type: 'EmbroideryTexture',
  bandWidth: 8, // width (in source px) of one light+dark thread ridge — set per-object so it reads at any zoom/scale
  mainParameter: 'bandWidth',
  applyTo: function(options){ this.applyTo2d(options); }, // always run on the 2D canvas backend
  applyTo2d: function(options){
    const data = options.imageData.data;
    const w = options.imageData.width, h = options.imageData.height;
    const n = w * h;
    const bw = this.bandWidth || 8;

    const alpha = new Uint8Array(n);
    for(let p = 0; p < n; p++) alpha[p] = data[p*4+3] > 10 ? 1 : 0;

    // chamfer distance transform: for each opaque pixel, its approximate
    // distance (in px) to the nearest transparent pixel
    const INF = 1e6;
    const dist = new Float32Array(n);
    for(let p = 0; p < n; p++) dist[p] = alpha[p] ? INF : 0;
    const D1 = 1, D2 = 1.41421356;
    for(let y = 0; y < h; y++){
      const row = y*w;
      for(let x = 0; x < w; x++){
        const idx = row + x;
        if(!alpha[idx]) continue;
        let best = dist[idx];
        if(x > 0) best = Math.min(best, dist[idx-1] + D1);
        if(y > 0) best = Math.min(best, dist[idx-w] + D1);
        if(x > 0 && y > 0) best = Math.min(best, dist[idx-w-1] + D2);
        if(x < w-1 && y > 0) best = Math.min(best, dist[idx-w+1] + D2);
        dist[idx] = best;
      }
    }
    for(let y = h-1; y >= 0; y--){
      const row = y*w;
      for(let x = w-1; x >= 0; x--){
        const idx = row + x;
        if(!alpha[idx]) continue;
        let best = dist[idx];
        if(x < w-1) best = Math.min(best, dist[idx+1] + D1);
        if(y < h-1) best = Math.min(best, dist[idx+w] + D1);
        if(x < w-1 && y < h-1) best = Math.min(best, dist[idx+w+1] + D2);
        if(x > 0 && y < h-1) best = Math.min(best, dist[idx+w-1] + D2);
        dist[idx] = best;
      }
    }

    const outlineWidth = Math.max(1.2, bw * 0.16);
    for(let y = 0; y < h; y++){
      for(let x = 0; x < w; x++){
        const idx = y*w + x;
        if(!alpha[idx]) continue;
        const i4 = idx*4;

        const xm = x > 0 ? x-1 : x, xp = x < w-1 ? x+1 : x;
        const ym = y > 0 ? y-1 : y, yp = y < h-1 ? y+1 : y;
        const gx = dist[y*w+xp] - dist[y*w+xm];
        const gy = dist[yp*w+x] - dist[ym*w+x];
        const mag = Math.hypot(gx, gy);
        // near-flat interior (far from any edge, e.g. a big fill area):
        // fall back to a fixed diagonal so it still reads as stitched
        const angle = mag < 0.08 ? Math.PI/4 : Math.atan2(gy, gx);

        const proj = x*Math.cos(angle) + y*Math.sin(angle);
        const factor = 1 + 0.5 * Math.sin(proj/bw*Math.PI);
        data[i4]   = Math.max(0, Math.min(255, data[i4]   * factor));
        data[i4+1] = Math.max(0, Math.min(255, data[i4+1] * factor));
        data[i4+2] = Math.max(0, Math.min(255, data[i4+2] * factor));

        // running-stitch dashed outline right at the boundary
        if(dist[idx] <= outlineWidth){
          const dashOn = Math.floor((x - y) / Math.max(2, bw*0.4)) % 2 === 0;
          if(dashOn){
            data[i4]   *= 0.55;
            data[i4+1] *= 0.55;
            data[i4+2] *= 0.55;
          }
        }
      }
    }
  },
});
/* fabric.util.createClass doesn't inherit static methods, so the
   loadFromJSON -> fromObject reconstruction path needs this wired up
   explicitly or every reload of an embroidered design throws silently */
fabric.Image.filters.EmbroideryTexture.fromObject = fabric.Image.filters.BaseFilter.fromObject;

/* fabric 5.x ships no Posterize filter (that's a fabric 6.x addition) —
   this flattens gradients/anti-aliasing into a handful of flat "thread
   colors" the same way, for the limited-palette embroidery look */
fabric.Image.filters.SimplePosterize = fabric.util.createClass(fabric.Image.filters.BaseFilter, {
  type: 'SimplePosterize',
  levels: 6,
  mainParameter: 'levels',
  applyTo: function(options){ this.applyTo2d(options); },
  applyTo2d: function(options){
    const data = options.imageData.data;
    const levels = Math.max(2, this.levels || 6);
    const step = 255 / (levels - 1);
    for(let i = 0; i < data.length; i += 4){
      if(data[i+3] === 0) continue;
      data[i]   = Math.round(Math.round(data[i]  /step) * step);
      data[i+1] = Math.round(Math.round(data[i+1]/step) * step);
      data[i+2] = Math.round(Math.round(data[i+2]/step) * step);
    }
  },
});
fabric.Image.filters.SimplePosterize.fromObject = fabric.Image.filters.BaseFilter.fromObject;

const EMBROIDERY_SHADOW = new fabric.Shadow({ color:'rgba(0,0,0,0.45)', blur:3, offsetX:1.5, offsetY:1.5 });

/* keeps the thread-ridge width reading as ~2.5 screen px wide no matter how
   big/small the design currently is, by sizing it in the image's own
   source-pixel space relative to its current on-canvas scale */
function embroideryBandWidth(obj){
  const scale = Math.max(obj.scaleX || 1, obj.scaleY || 1, 0.01);
  return Math.max(3, Math.min(60, 3.2 / scale));
}

/* rebuilds an image object's filter chain from scratch based on which
   print method it was created under (obj.printMethod) and whatever custom
   thread/ink color the user picked (obj.__tintColor) */
function rebuildImageFilters(obj){
  const filters = [];
  if(obj.printMethod === 'embroidery'){
    filters.push(new fabric.Image.filters.Contrast({ contrast: 0.22 }));
    filters.push(new fabric.Image.filters.Saturation({ saturation: 0.3 }));
    filters.push(new fabric.Image.filters.SimplePosterize({ levels: 6 })); // flatten to a handful of "thread colors"
  }
  if(obj.__tintColor){
    filters.push(new fabric.Image.filters.BlendColor({ color: obj.__tintColor, mode: 'tint', alpha: 1 }));
  }
  if(obj.printMethod === 'embroidery'){
    filters.push(new fabric.Image.filters.EmbroideryTexture({ bandWidth: embroideryBandWidth(obj) }));
  }
  obj.filters = filters;
  obj.shadow = obj.printMethod === 'embroidery' ? EMBROIDERY_SHADOW : null;
  obj.applyFilters();
}

/* ---------------------------------------------------------
   STATE
--------------------------------------------------------- */
const state = {
  product: 'tshirt',
  colorKey: 'black',
  size: 'XL',
  activeLocation: 'front', // one of LOCATIONS[].key
  method: 'print', // 'print' or 'embroidery'
  activeTab: 'upload',
  designs: {}, // key: `${product}_${locationKey}` -> fabric JSON
  uploadedAssets: [], // {id, name, dataUrl} reusable across all locations
};

/* the untouched file behind every uploaded image, by asset id. Kept apart from
   state.uploadedAssets because removing a logo from the library must not lose
   the original of a copy that is still placed on the shirt */
const ORIGINAL_FILES = new Map();

/* live Shopify product data (variants, real prices) fetched once on init —
   filled in by loadProductData(); Add to Cart and price display fall back
   to the placeholder BASE_PRICE numbers above until this resolves */
const PRODUCT_DATA = { tshirt: null, hoodie: null };

function currentColor(){
  return PRODUCT_COLORS[state.product].find(c=>c.key===state.colorKey) || PRODUCT_COLORS[state.product][0];
}
function currentLocation(){
  return LOCATIONS.find(l=>l.key===state.activeLocation);
}
function designKey(){
  return state.product + '_' + state.activeLocation;
}

function loadProductData(){
  Object.keys(PRODUCT_HANDLES).forEach(product=>{
    fetch(`/products/${PRODUCT_HANDLES[product]}.js`)
      .then(r=>r.ok ? r.json() : null)
      .then(data=>{
        if(!data) return;
        PRODUCT_DATA[product] = data;
        updatePrice();
      })
      .catch(()=>{ /* keep placeholder pricing/variant lookup disabled */ });
  });
}

/* finds the real Shopify variant id for the current product/size/color —
   Size was added as the product's first option, Color as the second, so
   option1/option2 line up directly with our own state */
function currentVariant(){
  const data = PRODUCT_DATA[state.product];
  if(!data) return null;
  const colorName = currentColor().name;
  return data.variants.find(v => v.option1 === state.size && v.option2 === colorName) || null;
}

/* ---------------------------------------------------------
   FABRIC CANVAS
--------------------------------------------------------- */
let fabricCanvas;
/* true while loadCurrentDesign() is clearing/reloading the canvas for a
   location switch, so the internal object:added/removed events fabric
   fires during that process don't get saved under the (already-updated)
   new location's key and clobber it with an empty/partial snapshot */
let suppressPersist = false;
/* bumped on every loadCurrentDesign() call so a loadFromJSON callback that
   finishes after a newer location switch already started can recognize
   it's stale (e.g. two location clicks fired faster than an image decode)
   and discard itself instead of corrupting the now-current canvas */
let loadToken = 0;

function initCanvas(){
  fabricCanvas = new fabric.Canvas('designCanvas', {
    selection: true,
    preserveObjectStacking: true,
  });
  fabric.Object.prototype.cornerSize = 14;
  fabric.Object.prototype.touchCornerSize = 34;
  fabric.Object.prototype.cornerColor = '#111113';
  fabric.Object.prototype.cornerStyle = 'circle';
  fabric.Object.prototype.transparentCorners = false;
  fabric.Object.prototype.borderColor = '#111113';
  fabric.Object.prototype.borderScaleFactor = 1.5;
  fabric.Object.prototype.padding = 4;
  fabricCanvas.uniformScaling = true; // corner drag always scales proportionally

  fabricCanvas.on('object:moving', (e)=>updateZoneWarning());
  fabricCanvas.on('object:scaling', (e)=>updateZoneWarning());
  fabricCanvas.on('object:rotating', (e)=>updateZoneWarning());
  fabricCanvas.on('object:modified', (e) => {
    if(suppressPersist) return;
    // keep the thread-ridge density consistent after a resize drag
    if(e.target && e.target.type === 'image' && e.target.printMethod === 'embroidery'){
      rebuildImageFilters(e.target);
      fabricCanvas.renderAll();
    }
    persistCurrentDesign();
    updateZoneWarning();
  });
  fabricCanvas.on('object:added', (e) => {
    restrictObjectControls(e.target);
    if(suppressPersist) return;
    persistCurrentDesign(); renderLocButtons(); updatePrice(); updateZoneWarning();
  });
  fabricCanvas.on('object:removed', () => { if(suppressPersist) return; persistCurrentDesign(); renderLocButtons(); updatePrice(); updateZoneWarning(); });
  fabricCanvas.on('selection:created', updateLogoColorFromSelection);
  fabricCanvas.on('selection:updated', updateLogoColorFromSelection);
  fabricCanvas.on('selection:cleared', updateLogoColorFromSelection);
}

function updateLogoColorFromSelection(){
  renderAssetGallery();
}

/* only the 4 corner handles stay active (uniform-scale, no stretching) —
   the edge (mt/mb/ml/mr) handles are hidden so a logo can never be
   distorted into a non-uniform shape, only resized keeping its ratio */
function restrictObjectControls(obj){
  obj.setControlsVisibility({ mt:false, mb:false, ml:false, mr:false, tl:true, tr:true, bl:true, br:true, mtr:true });
  obj.lockUniScaling = true;
  obj.lockSkewingX = true;
  obj.lockSkewingY = true;
}

/* the design is free to move/resize anywhere now (no hard clamp) — instead
   the dashed print-zone guide turns red and a warning appears whenever a
   design's bounding box no longer fits fully inside the safe area */
function isObjectInZone(obj, zr){
  obj.setCoords();
  const br = obj.getBoundingRect(true, true);
  return br.left >= zr.left - 0.5 && br.top >= zr.top - 0.5 &&
    (br.left + br.width) <= (zr.left + zr.width) + 0.5 &&
    (br.top + br.height) <= (zr.top + zr.height) + 0.5;
}

function updateZoneWarning(){
  const printZoneEl = document.querySelector('.print-zone');
  const warningEl = document.getElementById('zoneWarning');
  if(!printZoneEl || !fabricCanvas) return;
  const zr = getZoneRect(fabricCanvas.getWidth(), fabricCanvas.getHeight());
  const outOfBounds = fabricCanvas.getObjects().some(o=>!isObjectInZone(o, zr));
  printZoneEl.classList.toggle('out-of-bounds', outOfBounds);
  if(warningEl) warningEl.hidden = !outOfBounds;
}

/* the fabric canvas covers the ENTIRE product photo (not just the print
   area) so drag/resize/rotate handles are never clipped and stay smooth;
   the dashed print-zone rect is only a visual placement guide on top */
function layoutCanvas(){
  const stageWrap = document.getElementById('stageWrap');
  const holder = document.getElementById('canvasHolder');
  const rect = stageWrap.getBoundingClientRect();

  holder.style.left = '0px';
  holder.style.top = '0px';
  holder.style.width = rect.width+'px';
  holder.style.height = rect.height+'px';

  fabricCanvas.setWidth(rect.width);
  fabricCanvas.setHeight(rect.height);
  fabricCanvas.calcOffset();
  fabricCanvas.renderAll();

  drawPrintZoneGuide(rect.width, rect.height);
}

function getZoneRect(canvasWidth, canvasHeight){
  const loc = currentLocation();
  const zone = PRINT_ZONES[state.product][loc.view][loc.size];
  return {
    left: canvasWidth * (zone.x/100),
    top: canvasHeight * (zone.y/100),
    width: canvasWidth * (zone.w/100),
    height: canvasHeight * (zone.h/100),
  };
}

function drawPrintZoneGuide(canvasWidth, canvasHeight){
  const stageWrap = document.getElementById('stageWrap');
  const zr = getZoneRect(canvasWidth, canvasHeight);
  let printZoneEl = stageWrap.querySelector('.print-zone');
  if(!printZoneEl){
    printZoneEl = document.createElement('div');
    printZoneEl.className = 'print-zone';
    stageWrap.appendChild(printZoneEl);
  }
  printZoneEl.style.left = zr.left+'px';
  printZoneEl.style.top = zr.top+'px';
  printZoneEl.style.width = zr.width+'px';
  printZoneEl.style.height = zr.height+'px';
}

function persistCurrentDesign(){
  const data = fabricCanvas.toJSON(['assetId', 'printMethod', '__tintColor']);
  // stash the exact pixel size this design was drawn at, so a later
  // preview render (for the cart/order) can reproduce the same layout
  data.__stageW = fabricCanvas.getWidth();
  data.__stageH = fabricCanvas.getHeight();
  state.designs[designKey()] = data;
}

function loadCurrentDesign(){
  const myToken = ++loadToken;
  suppressPersist = true;
  fabricCanvas.clear();
  const data = state.designs[designKey()];
  if(data && data.objects && data.objects.length){
    fabricCanvas.loadFromJSON(data, ()=>{
      if(myToken !== loadToken) return; // a newer location switch already superseded this load
      fabricCanvas.getObjects().forEach(restrictObjectControls);
      suppressPersist = false;
      fabricCanvas.renderAll();
      updateZoneWarning();
      renderAssetGallery();
    });
  } else {
    suppressPersist = false;
    updateZoneWarning();
    renderAssetGallery();
  }
}

function updateStagePhoto(){
  const dims = PRODUCT_IMAGE_DIMS[state.product];
  const stageWrap = document.getElementById('stageWrap');
  stageWrap.style.aspectRatio = `${dims.w} / ${dims.h}`;
  document.getElementById('shirtPhoto').src = imagePath(state.product, state.colorKey, currentLocation().view);
}

function switchLocation(key){
  persistCurrentDesign();
  state.activeLocation = key;
  document.getElementById('designForTitle').textContent = '6. DESIGN FOR: ' + currentLocation().label.toUpperCase();
  updateStagePhoto();
  layoutCanvas();
  loadCurrentDesign();
  renderViewThumbs();
  renderMiniThumbs();
  renderLocButtons();
}

/* ---------------------------------------------------------
   ADD IMAGE / TEXT TO CANVAS
--------------------------------------------------------- */
function addImageToCanvas(dataUrl, assetId){
  const zr = getZoneRect(fabricCanvas.getWidth(), fabricCanvas.getHeight());
  fabric.Image.fromURL(dataUrl, (img)=>{
    const maxDim = Math.min(zr.width, zr.height) * 0.9;
    const scale = maxDim / Math.max(img.width, img.height);
    img.set({
      left: zr.left + zr.width/2,
      top: zr.top + zr.height/2,
      originX:'center', originY:'center',
      scaleX: scale, scaleY: scale,
      assetId: assetId,
      printMethod: state.method,
    });
    rebuildImageFilters(img);
    fabricCanvas.add(img);
    fabricCanvas.setActiveObject(img);
    fabricCanvas.renderAll();
    renderAssetGallery();
  }, {crossOrigin:'anonymous'});
}

function addTextToCanvas(){
  if(state.method === 'embroidery') return addEmbroideredTextToCanvas();

  const zr = getZoneRect(fabricCanvas.getWidth(), fabricCanvas.getHeight());
  const text = document.getElementById('textInput').value || 'YOUR TEXT';
  const font = document.getElementById('fontSelect').value;
  const size = parseInt(document.getElementById('fontSizeInput').value)||48;
  const color = document.getElementById('fontColorInput').value;

  const t = new fabric.Textbox(text, {
    left: zr.left + zr.width/2,
    top: zr.top + zr.height/2,
    originX:'center', originY:'center',
    fontFamily: font.replace(/'/g,''),
    fontSize: Math.max(10, size/3),
    fill: color,
    textAlign: 'center',
    width: zr.width*0.9,
    printMethod: state.method,
  });
  fabricCanvas.add(t);
  fabricCanvas.setActiveObject(t);
  fabricCanvas.renderAll();
  return t;
}

/* draws the current text-panel text/font/size/color to an offscreen canvas
   at high resolution, then runs it through the SAME embroidery pixel
   filter as an uploaded logo — this is what lets embroidered text follow
   each letter's contour instead of just getting a flat color */
function renderTextToDataURL(text, fontFamily, fontSize){
  const upscale = 4;
  const px = Math.max(10, fontSize) * upscale;
  const measure = document.createElement('canvas').getContext('2d');
  measure.font = `700 ${px}px "${fontFamily}"`;
  const metrics = measure.measureText(text);
  const padding = px * 0.35;
  const w = Math.max(1, Math.ceil(metrics.width + padding*2));
  const h = Math.max(1, Math.ceil(px * 1.5));
  const c = document.createElement('canvas');
  c.width = w; c.height = h;
  const ctx = c.getContext('2d');
  ctx.font = `700 ${px}px "${fontFamily}"`;
  ctx.fillStyle = document.getElementById('fontColorInput').value;
  ctx.textBaseline = 'middle';
  ctx.textAlign = 'center';
  ctx.fillText(text, w/2, h/2);
  return { dataUrl: c.toDataURL('image/png'), width: w, height: h };
}

function addEmbroideredTextToCanvas(){
  const zr = getZoneRect(fabricCanvas.getWidth(), fabricCanvas.getHeight());
  const text = document.getElementById('textInput').value || 'YOUR TEXT';
  const font = document.getElementById('fontSelect').value.replace(/'/g,'');
  const size = parseInt(document.getElementById('fontSizeInput').value)||48;

  const ready = document.fonts && document.fonts.load ? document.fonts.load(`700 40px "${font}"`) : Promise.resolve();
  return ready.then(()=> new Promise((resolve)=>{
    const { dataUrl, width, height } = renderTextToDataURL(text, font, size);
    fabric.Image.fromURL(dataUrl, (img)=>{
      const maxDim = Math.min(zr.width, zr.height) * 0.85;
      const scale = maxDim / Math.max(width, height, 1);
      img.set({
        left: zr.left + zr.width/2,
        top: zr.top + zr.height/2,
        originX:'center', originY:'center',
        scaleX: scale, scaleY: scale,
        printMethod: 'embroidery',
        isEmbroideredText: true,
      });
      rebuildImageFilters(img);
      fabricCanvas.add(img);
      fabricCanvas.setActiveObject(img);
      fabricCanvas.renderAll();
      resolve(img);
    }, {crossOrigin:'anonymous'});
  }));
}

let embroideryRegenTimer = null;
/* the embroidered-text object is a raster, so editing its text/font/size
   means regenerating it from scratch (debounced so fast typing doesn't
   thrash) — note this recenters it in the print zone, so a manual
   move/resize done before an edit isn't preserved (only rotation is) */
function regenerateEmbroideredText(oldObj){
  clearTimeout(embroideryRegenTimer);
  embroideryRegenTimer = setTimeout(()=>{
    const angle = oldObj.angle || 0;
    fabricCanvas.remove(oldObj);
    addEmbroideredTextToCanvas().then((img)=>{
      img.rotate(angle);
      fabricCanvas.renderAll();
      persistCurrentDesign();
    });
  }, 350);
}

function activeTextObject(){
  const obj = fabricCanvas.getActiveObject();
  if(!obj) return null;
  return (obj.type === 'textbox' || obj.isEmbroideredText) ? obj : null;
}

/* ---------------------------------------------------------
   RENDER: PRODUCT / COLOR / SIZE / VIEW
--------------------------------------------------------- */
function renderProductGroup(){
  document.querySelectorAll('#productGroup .pill-btn').forEach(btn=>{
    btn.classList.toggle('selected', btn.dataset.product===state.product);
  });
}

function renderMethodGroup(){
  const wrap = document.getElementById('methodGroup');
  wrap.innerHTML = '';
  PRINT_METHODS.forEach(m=>{
    const btn = document.createElement('button');
    btn.className = 'pill-btn' + (state.method===m.key ? ' selected':'');
    btn.innerHTML = `${m.icon} ${m.label}`;
    btn.addEventListener('click', ()=>{
      state.method = m.key;
      renderMethodGroup();
      updatePrice();
    });
    wrap.appendChild(btn);
  });
  document.getElementById('methodHint').textContent = PRINT_METHODS.find(m=>m.key===state.method).hint;
}

function renderColorGroup(){
  const wrap = document.getElementById('colorGroup');
  wrap.innerHTML = '';
  PRODUCT_COLORS[state.product].forEach(c=>{
    const el = document.createElement('div');
    el.className = 'b3-swatch' + (state.colorKey===c.key ? ' selected':'');
    el.style.background = c.hex;
    if(c.hex.toLowerCase() === '#ffffff') el.style.boxShadow = 'inset 0 0 0 1px #ddd';
    el.title = c.name;
    el.addEventListener('click', ()=>{
      state.colorKey = c.key;
      renderColorGroup();
      updateStagePhoto();
      renderViewThumbs();
      renderMiniThumbs();
      updatePrice();
    });
    wrap.appendChild(el);
  });
}

function renderSizeGroup(){
  const wrap = document.getElementById('sizeGroup');
  wrap.innerHTML = '';
  SIZES.forEach(s=>{
    const btn = document.createElement('button');
    btn.className = 'size-btn' + (state.size===s?' selected':'');
    btn.textContent = s;
    btn.addEventListener('click', ()=>{ state.size=s; renderSizeGroup(); updatePrice(); });
    wrap.appendChild(btn);
  });
}

function openSizeChart(){
  const rows = SIZE_CHARTS[state.product] || [];
  document.getElementById('sizeChartTitle').textContent =
    (state.product === 'tshirt' ? 'T-Shirt' : 'Hoodie') + ' Size Guide';
  document.getElementById('sizeChartBody').innerHTML = rows
    .map(r => `<tr><td>${r.size}</td><td>${r.w}</td><td>${r.h}</td></tr>`)
    .join('');
  document.getElementById('sizeChartModal').hidden = false;
}
function closeSizeChart(){
  document.getElementById('sizeChartModal').hidden = true;
}

function renderLocButtons(){
  const wrap = document.getElementById('locGroup');
  wrap.innerHTML = '';
  LOCATIONS.forEach(loc=>{
    const btn = document.createElement('button');
    const key = state.product+'_'+loc.key;
    const data = state.designs[key];
    const hasDesign = !!(data && data.objects && data.objects.length);
    btn.className = 'loc-btn' + (state.activeLocation===loc.key?' selected':'') + (hasDesign?' has-design':'');
    btn.innerHTML = `<span class="dot"></span> ${loc.label} ${hasDesign?'<span class="badge">✓</span>':''}`;
    btn.addEventListener('click', ()=>switchLocation(loc.key));
    wrap.appendChild(btn);
  });
}

function renderViewThumbs(){
  const wrap = document.getElementById('viewThumbs');
  wrap.innerHTML = '';
  const activeView = currentLocation().view;
  PHOTO_VIEWS.forEach(v=>{
    const el = document.createElement('div');
    el.className = 'view-thumb' + (activeView===v.key?' active':'');
    el.innerHTML = `<img src="${imagePath(state.product, state.colorKey, v.key)}"><span>${v.label.toUpperCase()}</span>`;
    el.addEventListener('click', ()=>switchLocation(v.key));
    wrap.appendChild(el);
  });
}

function renderMiniThumbs(){
  const wrap = document.getElementById('miniThumbs');
  wrap.innerHTML = '';
  const activeView = currentLocation().view;
  PHOTO_VIEWS.forEach(v=>{
    const el = document.createElement('div');
    el.className = 'mini-thumb' + (activeView===v.key?' active':'');
    el.innerHTML = `<img src="${imagePath(state.product, state.colorKey, v.key)}">`;
    el.addEventListener('click', ()=>switchLocation(v.key));
    wrap.appendChild(el);
  });
}

/* ---------------------------------------------------------
   PRICE
--------------------------------------------------------- */
function designedLocationsCount(){
  return LOCATIONS.filter(loc=>{
    const d = state.designs[state.product+'_'+loc.key];
    return d && d.objects && d.objects.length;
  }).length;
}

function updatePrice(){
  const select = document.getElementById('printsSelect');
  const designedCount = designedLocationsCount();
  if(document.activeElement !== select){
    select.value = Math.min(4, Math.max(1, designedCount)).toString();
  }

  // prefer the real live Shopify variant price once it has loaded — it's
  // always the blank-garment price now, with every print/embroidery location
  // charged on top via EXTRA_PRINT_PRICE (must match what confirmAddToCart()
  // actually charges via the "Extra Print" add-on product, or the total
  // shown here would drift from the total charged at checkout)
  const variant = currentVariant();
  const garmentBase = variant ? variant.price/100 : BASE_PRICE[state.product];
  const perLocation = EXTRA_PRINT_PRICE[state.method];
  const total = garmentBase + perLocation * designedCount;
  document.getElementById('priceTotal').textContent = total + ' JOD';
  document.getElementById('cartBtnPrice').textContent = total + ' JOD';
}

/* ---------------------------------------------------------
   EVENTS
--------------------------------------------------------- */
function bindEvents(){
  document.querySelectorAll('#productGroup .pill-btn').forEach(btn=>{
    btn.addEventListener('click', ()=>{
      persistCurrentDesign();
      state.product = btn.dataset.product;
      state.colorKey = PRODUCT_COLORS[state.product][0].key;
      renderProductGroup();
      renderColorGroup();
      updateStagePhoto();
      layoutCanvas();
      loadCurrentDesign();
      renderViewThumbs();
      renderMiniThumbs();
      renderLocButtons();
      updatePrice();
    });
  });

  document.querySelectorAll('.design-tab').forEach(tab=>{
    tab.addEventListener('click', ()=>{
      document.querySelectorAll('.design-tab').forEach(t=>t.classList.remove('active'));
      tab.classList.add('active');
      state.activeTab = tab.dataset.tab;
      document.getElementById('uploadPanel').style.display = state.activeTab==='upload' ? 'block':'none';
      document.getElementById('textPanel').style.display = state.activeTab==='text' ? 'block':'none';
    });
  });

  const dropzone = document.getElementById('dropzone');
  const fileInput = document.getElementById('fileInput');
  dropzone.addEventListener('click', ()=>fileInput.click());
  dropzone.addEventListener('dragover', e=>{e.preventDefault(); dropzone.style.background='#f0f0f2';});
  dropzone.addEventListener('dragleave', ()=>{dropzone.style.background='';});
  dropzone.addEventListener('drop', e=>{
    e.preventDefault();
    dropzone.style.background='';
    if(e.dataTransfer.files.length) handleFile(e.dataTransfer.files[0]);
  });
  fileInput.addEventListener('change', e=>{
    if(e.target.files.length) handleFile(e.target.files[0]);
  });

  document.getElementById('rotateBtn').addEventListener('click', ()=>rotateActive(15));
  document.getElementById('deleteBtn').addEventListener('click', deleteActive);
  document.getElementById('resetBtn').addEventListener('click', resetActiveView);

  document.addEventListener('keydown', (e)=>{
    if((e.key === 'Delete' || e.key === 'Backspace') && fabricCanvas.getActiveObject() && document.activeElement.tagName !== 'TEXTAREA' && document.activeElement.tagName !== 'INPUT'){
      deleteActive();
    }
  });

  document.getElementById('textInput').addEventListener('input', syncActiveTextFromControls);
  document.getElementById('fontSelect').addEventListener('change', syncActiveTextFromControls);
  document.getElementById('fontSizeInput').addEventListener('input', syncActiveTextFromControls);
  document.getElementById('fontColorInput').addEventListener('input', syncActiveTextFromControls);

  document.getElementById('boldBtn').addEventListener('click', ()=>toggleTextProp('fontWeight','bold','normal','boldBtn'));
  document.getElementById('italicBtn').addEventListener('click', ()=>toggleTextProp('fontStyle','italic','normal','italicBtn'));
  document.getElementById('underlineBtn').addEventListener('click', ()=>toggleTextProp('underline', true, false, 'underlineBtn'));
  document.getElementById('alignLeftBtn').addEventListener('click', ()=>setAlign('left','alignLeftBtn'));
  document.getElementById('alignCenterBtn').addEventListener('click', ()=>setAlign('center','alignCenterBtn'));
  document.getElementById('alignRightBtn').addEventListener('click', ()=>setAlign('right','alignRightBtn'));

  document.getElementById('logoColorInput').addEventListener('input', (e)=>applyLogoColor(e.target.value));
  document.getElementById('logoColorResetBtn').addEventListener('click', resetLogoColor);

  document.getElementById('printsSelect').addEventListener('change', updatePrice);
  document.getElementById('addCartBtn').addEventListener('click', openPreviewModal);

  window.addEventListener('resize', layoutCanvas);

  document.getElementById('sizeChartBtn').addEventListener('click', openSizeChart);
  document.getElementById('sizeChartClose').addEventListener('click', closeSizeChart);
  document.getElementById('sizeChartModal').addEventListener('click', (e)=>{
    if(e.target.id === 'sizeChartModal') closeSizeChart();
  });
  document.getElementById('previewModalClose').addEventListener('click', closePreviewModal);
  document.getElementById('previewModal').addEventListener('click', (e)=>{
    if(e.target.id === 'previewModal') closePreviewModal();
  });
  document.addEventListener('keydown', (e)=>{
    if(e.key !== 'Escape') return;
    closeSizeChart();
    closePreviewModal();
  });
}

/* uploaded files are kept in a small reusable library (state.uploadedAssets)
   so the user can place the same logo on several print locations without
   re-uploading it every time */
function handleFile(file){
  // Only formats we can preview on the shirt and print from directly. The
  // Cloudinary upload preset enforces the same list, so anything else would
  // be refused at checkout time rather than here.
  const isImage = /\.(png|jpe?g|svg)$/i.test(file.name);
  if(!isImage){
    showToast('Please upload a PNG, JPG or SVG file.');
    return;
  }
  const reader = new FileReader();
  reader.onload = (e)=>{
    trimTransparentPadding(e.target.result).then((trimmedUrl)=>{
      const asset = { id: 'a'+Date.now()+Math.random().toString(36).slice(2,7), name: file.name, dataUrl: trimmedUrl };
      ORIGINAL_FILES.set(asset.id, file);
      state.uploadedAssets.push(asset);
      renderAssetGallery();
      placeAssetOnCanvas(asset);
      warnIfLowResolution(file, trimmedUrl);
    });
  };
  reader.readAsDataURL(file);
}

/* a small photo can look fine on screen and still print as a blur — tell the
   customer while they can still pick a bigger file, rather than after it's
   printed. SVG is vector, so it's never too small. */
const MIN_PRINT_LONG_SIDE = 1500;
function warnIfLowResolution(file, dataUrl){
  if(/\.svg$/i.test(file.name)) return;
  const img = new Image();
  img.onload = ()=>{
    if(Math.max(img.naturalWidth, img.naturalHeight) < MIN_PRINT_LONG_SIDE){
      showToast(`Low resolution image (${img.naturalWidth}×${img.naturalHeight}px) — it may print blurry. A larger file will look sharper.`);
    }
  };
  img.src = dataUrl;
}

/* many exported logos carry a lot of empty transparent canvas around the
   actual artwork — that empty space was making the auto-fit sizing and
   the safe-area check use the WHOLE image's bounds instead of the visible
   logo, so the selection box (and the "outside the safe area" warning)
   looked wrong relative to what's actually drawn. This crops the image
   down to the tight bounding box of its non-transparent pixels first. */
function trimTransparentPadding(dataUrl){
  return new Promise((resolve)=>{
    const img = new Image();
    img.onload = () => {
      const w0 = img.naturalWidth, h0 = img.naturalHeight;
      const c = document.createElement('canvas');
      c.width = w0; c.height = h0;
      const ctx = c.getContext('2d');
      ctx.drawImage(img, 0, 0);
      let data;
      try { data = ctx.getImageData(0, 0, w0, h0).data; }
      catch(e){ resolve(dataUrl); return; } // e.g. tainted canvas — skip trimming, use as-is
      let minX = w0, minY = h0, maxX = -1, maxY = -1;
      for(let y = 0; y < h0; y++){
        for(let x = 0; x < w0; x++){
          if(data[(y*w0 + x)*4 + 3] > 10){
            if(x < minX) minX = x;
            if(x > maxX) maxX = x;
            if(y < minY) minY = y;
            if(y > maxY) maxY = y;
          }
        }
      }
      if(maxX < 0){ resolve(dataUrl); return; } // fully transparent file
      const w = maxX - minX + 1, h = maxY - minY + 1;
      if(w === w0 && h === h0){ resolve(dataUrl); return; } // nothing to trim (e.g. a JPG with no alpha)
      const out = document.createElement('canvas');
      out.width = w; out.height = h;
      out.getContext('2d').drawImage(c, minX, minY, w, h, 0, 0, w, h);
      resolve(out.toDataURL('image/png'));
    };
    img.onerror = () => resolve(dataUrl);
    img.src = dataUrl;
  });
}

function renderAssetGallery(){
  const wrap = document.getElementById('assetGallery');
  wrap.innerHTML = '';
  const activeObj = fabricCanvas.getActiveObject();
  state.uploadedAssets.forEach(asset=>{
    const el = document.createElement('div');
    el.className = 'asset-thumb' + (activeObj && activeObj.assetId===asset.id ? ' active' : '');
    el.innerHTML = `<img src="${asset.dataUrl}"><button class="del" title="Remove from library">✕</button>`;
    el.querySelector('img').addEventListener('click', ()=>placeAssetOnCanvas(asset));
    el.querySelector('.del').addEventListener('click', (ev)=>{
      ev.stopPropagation();
      state.uploadedAssets = state.uploadedAssets.filter(a=>a.id!==asset.id);
      renderAssetGallery();
    });
    wrap.appendChild(el);
  });
}

function placeAssetOnCanvas(asset){
  addImageToCanvas(asset.dataUrl, asset.id);
}

function rotateActive(deg){
  const obj = fabricCanvas.getActiveObject();
  if(!obj) return;
  obj.rotate((obj.angle||0) + deg);
  fabricCanvas.renderAll();
  persistCurrentDesign();
}
function deleteActive(){
  const obj = fabricCanvas.getActiveObject();
  if(!obj) return;
  fabricCanvas.remove(obj);
  fabricCanvas.discardActiveObject();
  fabricCanvas.renderAll();
}
function resetActiveView(){
  fabricCanvas.clear();
  delete state.designs[designKey()];
  renderLocButtons();
  updatePrice();
}

/* recolors an uploaded logo/PNG/SVG image in place (works best on
   single-color artwork with a transparent background) */
function applyLogoColor(hex){
  const obj = fabricCanvas.getActiveObject();
  if(!obj || obj.type !== 'image'){
    showToast('Select a logo on the canvas first to change its color');
    return;
  }
  obj.__tintColor = hex;
  rebuildImageFilters(obj);
  fabricCanvas.renderAll();
  persistCurrentDesign();
}
function resetLogoColor(){
  const obj = fabricCanvas.getActiveObject();
  if(!obj || obj.type !== 'image') return;
  obj.__tintColor = null;
  rebuildImageFilters(obj);
  fabricCanvas.renderAll();
  persistCurrentDesign();
}

function syncActiveTextFromControls(){
  const t = activeTextObject();
  if(!t && state.activeTab==='text'){
    addTextToCanvas(); // handles its own render + persist (async for embroidery)
    return;
  }
  if(t && t.isEmbroideredText){
    regenerateEmbroideredText(t); // handles its own render + persist (debounced)
    return;
  }
  if(t){
    t.set({
      text: document.getElementById('textInput').value,
      fontFamily: document.getElementById('fontSelect').value.replace(/'/g,''),
      fontSize: Math.max(10, (parseInt(document.getElementById('fontSizeInput').value)||48)/3),
      fill: document.getElementById('fontColorInput').value,
    });
    fabricCanvas.renderAll();
    persistCurrentDesign();
  }
}

function toggleTextProp(prop, onVal, offVal, btnId){
  const t = activeTextObject();
  if(!t) return;
  const isOn = t[prop] === onVal;
  t.set(prop, isOn ? offVal : onVal);
  document.getElementById(btnId).classList.toggle('active', !isOn);
  fabricCanvas.renderAll();
  persistCurrentDesign();
}

function setAlign(align, btnId){
  const t = activeTextObject();
  if(t){ t.set('textAlign', align); fabricCanvas.renderAll(); persistCurrentDesign(); }
  ['alignLeftBtn','alignCenterBtn','alignRightBtn'].forEach(id=>document.getElementById(id).classList.remove('active'));
  document.getElementById(btnId).classList.add('active');
}

/* ---------------------------------------------------------
   ADD TO CART (real Shopify variant + Cloudinary mockup upload)
--------------------------------------------------------- */

/* renders one saved design (fabric JSON) composited ON TOP OF the actual
   garment photo (correct product/color/view), at the exact pixel size it
   was drawn at, using an off-DOM static canvas — this full mockup is what
   gets shown in the preview modal AND uploaded to Cloudinary as the proof,
   so it's never just the design floating on a blank/transparent background */
function renderMockupPreview(product, colorKey, view, designData){
  return new Promise((resolve)=>{
    const w = designData.__stageW || 600;
    const h = designData.__stageH || 600;
    const staticCanvas = new fabric.StaticCanvas(null, { width: w, height: h });
    // load the design objects FIRST — loadFromJSON clears the canvas (including
    // any background already set on it), so the garment photo has to be set
    // as the background AFTER, or it gets wiped out and the export comes back
    // as just the design floating on a blank/transparent canvas
    staticCanvas.loadFromJSON({ objects: designData.objects || [] }, ()=>{
      fabric.Image.fromURL(imagePath(product, colorKey, view), (bgImg)=>{
        bgImg.set({
          left: 0, top: 0, originX: 'left', originY: 'top',
          scaleX: w / bgImg.width, scaleY: h / bgImg.height,
        });
        staticCanvas.setBackgroundImage(bgImg, ()=>{
          staticCanvas.renderAll();
          const dataUrl = staticCanvas.toDataURL({ format:'png' });
          staticCanvas.dispose();
          resolve(dataUrl);
        });
      }, { crossOrigin:'anonymous' });
    });
  });
}

/* ---------------------------------------------------------
   PRINT FILES
   The mockup above is a screen-sized picture of a shirt — fine to show the
   customer, useless to print from (a whole garment in ~400px leaves the
   design itself at ~15 dpi). So every order also carries the artwork on its
   own, transparent, at print resolution, plus the files the customer uploaded
   exactly as they sent them.
--------------------------------------------------------- */
const PRINT_FILE_LONG_SIDE = 3600;          // ~30 cm at 300 dpi
const PRINT_FILE_MAX_PIXELS = 12000000;     // under mobile Safari's canvas limit
const UPLOAD_MAX_BYTES = 9.5 * 1024 * 1024; // Cloudinary's free plan refuses files over 10 MB

/* renders just the placed objects — no garment, no embroidery simulation —
   cropped to what was actually drawn and scaled up to print size. Text and
   SVG come out sharp at any size; a raster comes out at its own resolution. */
function renderPrintFile(designData, scaleDown){
  return new Promise((resolve)=>{
    const w = designData.__stageW || 600;
    const h = designData.__stageH || 600;
    const staticCanvas = new fabric.StaticCanvas(null, { width: w, height: h, enableRetinaScaling: false });

    // WebGL filtering silently shrinks anything over fabric.textureSize (2048px),
    // which would undo the whole point on a large tinted logo
    const screenBackend = fabric.filterBackend;
    fabric.filterBackend = new fabric.Canvas2dFilterBackend();

    staticCanvas.loadFromJSON({ objects: designData.objects || [] }, ()=>{
      const objects = staticCanvas.getObjects();
      if(!objects.length){
        fabric.filterBackend = screenBackend;
        staticCanvas.dispose();
        resolve(null);
        return;
      }

      let x0 = Infinity, y0 = Infinity, x1 = -Infinity, y1 = -Infinity;
      objects.forEach((obj)=>{
        obj.objectCaching = false; // a cached bitmap would be scaled up blurry
        obj.shadow = null;
        if(obj.type === 'image'){
          // the thread texture is an on-screen preview; a chosen colour is real
          obj.filters = obj.__tintColor
            ? [new fabric.Image.filters.BlendColor({ color: obj.__tintColor, mode: 'tint', alpha: 1 })]
            : [];
          obj.applyFilters();
        }
        obj.setCoords();
        const b = obj.getBoundingRect(true, true);
        x0 = Math.min(x0, b.left);
        y0 = Math.min(y0, b.top);
        x1 = Math.max(x1, b.left + b.width);
        y1 = Math.max(y1, b.top + b.height);
      });

      const bw = Math.max(1, x1 - x0);
      const bh = Math.max(1, y1 - y0);
      const multiplier = Math.min(
        PRINT_FILE_LONG_SIDE / Math.max(bw, bh),
        Math.sqrt(PRINT_FILE_MAX_PIXELS / (bw * bh))
      ) * (scaleDown || 1);

      staticCanvas.renderAll();
      const dataUrl = staticCanvas.toDataURL({
        format: 'png', left: x0, top: y0, width: bw, height: bh, multiplier,
      });
      fabric.filterBackend = screenBackend;
      staticCanvas.dispose();
      resolve(dataUrl);
    });
  });
}

function dataUrlToBlob(dataUrl){
  return fetch(dataUrl).then(r=>r.blob());
}

/* unsigned upload straight from the browser — no server/API key needed.
   Cloud name + preset are set in the section's inline config script. */
function uploadToCloudinary(file, kind){
  const cfg = window.B3_CLOUDINARY || {};
  if(!cfg.cloudName || !cfg.uploadPreset){
    return Promise.reject(new Error('Cloudinary is not configured'));
  }
  const form = new FormData();
  form.append('file', file);
  form.append('upload_preset', cfg.uploadPreset);
  return fetch(`https://api.cloudinary.com/v1_1/${cfg.cloudName}/${kind || 'image'}/upload`, {
    method: 'POST',
    body: form,
  })
    .then(r=>r.json())
    .then(data=>{
      if(!data.secure_url) throw new Error(data.error && data.error.message || 'Upload failed');
      return data.secure_url;
    });
}

function uploadDesignToCloudinary(dataUrl){
  return dataUrlToBlob(dataUrl).then(blob => uploadToCloudinary(blob, 'image'));
}

/* a print-size PNG of a photo can pass the upload limit — step the size down
   until it fits rather than failing the order */
function uploadPrintFile(designData){
  const attempt = (scale, triesLeft) =>
    renderPrintFile(designData, scale)
      .then(dataUrl => dataUrl ? dataUrlToBlob(dataUrl) : null)
      .then(blob=>{
        if(!blob) return null;
        if(blob.size <= UPLOAD_MAX_BYTES) return uploadToCloudinary(blob, 'image');
        if(triesLeft <= 0) throw new Error('Print file too large');
        return attempt(scale * Math.sqrt(UPLOAD_MAX_BYTES / blob.size) * 0.95, triesLeft - 1);
      });
  return attempt(1, 3);
}

/* the same logo placed on front and back is one file — upload it once, and
   reuse the result if the customer hits Retry after a failed add */
const UPLOADED_ORIGINALS = new Map();
function uploadOriginal(key, file, kind){
  if(!UPLOADED_ORIGINALS.has(key)){
    const pending = uploadToCloudinary(file, kind);
    UPLOADED_ORIGINALS.set(key, pending);
    pending.catch(()=>UPLOADED_ORIGINALS.delete(key));
  }
  return UPLOADED_ORIGINALS.get(key);
}

/* a failed print file or original must not cost the customer their order —
   the mockup is enough to take it — so record the gap in the order instead */
const NOT_UPLOADED = 'Upload failed — ask the customer for this file';
const settle = (p) => p.then(url => url || NOT_UPLOADED, () => NOT_UPLOADED);

/* clicking Add to Cart opens a preview modal first (so the customer sees the
   actual garment with their design on it, not just an empty shirt) — the
   real cart-add only happens once they confirm from inside that modal */
function openPreviewModal(){
  persistCurrentDesign();

  const variant = currentVariant();
  if(!variant){
    showToast('Could not find this size/color online yet — please try again in a moment.');
    return;
  }

  const designedLocations = LOCATIONS
    .map(loc=>({ loc, data: state.designs[state.product+'_'+loc.key] }))
    .filter(({data}) => data && data.objects && data.objects.length);

  if(!designedLocations.length){
    showToast('Add a design or some text first so we can show you a preview.');
    return;
  }

  const modal = document.getElementById('previewModal');
  document.getElementById('previewModalBody').innerHTML = '<div class="preview-loading">Generating preview…</div>';
  document.getElementById('previewModalFooter').innerHTML = '';
  modal.hidden = false;

  const product = state.product, colorKey = state.colorKey;
  Promise.all(designedLocations.map(({loc, data}) =>
    renderMockupPreview(product, colorKey, loc.view, data).then(dataUrl => ({ loc, dataUrl }))
  )).then((results)=> renderPreviewModalContent(results, variant));
}

function renderPreviewModalContent(results, variant){
  document.getElementById('previewModalBody').innerHTML = `
    <div class="preview-grid">
      ${results.map(r => `
        <div class="preview-item">
          <img src="${r.dataUrl}" alt="${r.loc.label} preview">
          <span>${r.loc.label}</span>
        </div>
      `).join('')}
    </div>
    <div class="preview-summary">
      <span>${currentColor().name} · Size ${state.size}</span>
      <span class="preview-price">${document.getElementById('priceTotal').textContent}</span>
    </div>
  `;
  const footer = document.getElementById('previewModalFooter');
  footer.innerHTML = `
    <button type="button" class="preview-btn-secondary" id="previewEditBtn">✏️ Edit Design</button>
    <button type="button" class="preview-btn-primary" id="previewConfirmBtn">🛒 Confirm &amp; Add to Cart</button>
  `;
  document.getElementById('previewEditBtn').addEventListener('click', closePreviewModal);
  document.getElementById('previewConfirmBtn').addEventListener('click', ()=> confirmAddToCart(results, variant));
}

function confirmAddToCart(results, variant){
  const footer = document.getElementById('previewModalFooter');
  footer.innerHTML = '<span class="preview-status">Preparing your print files…</span>';

  const designFor = (loc) => state.designs[state.product + '_' + loc.key];

  const usedAssetIds = [];
  results.forEach(r => (designFor(r.loc).objects || []).forEach(o=>{
    if(o.assetId && ORIGINAL_FILES.has(o.assetId) && !usedAssetIds.includes(o.assetId)) usedAssetIds.push(o.assetId);
  }));

  const mockups = Promise.all(results.map(r => uploadDesignToCloudinary(r.dataUrl)));
  const printFiles = Promise.all(results.map(r => settle(uploadPrintFile(designFor(r.loc)))));
  const originals = Promise.all(usedAssetIds.map(id => settle(uploadOriginal(id, ORIGINAL_FILES.get(id), 'image'))));

  Promise.all([mockups, printFiles, originals])
    .then(([mockupUrls, printUrls, originalUrls])=>{
      // Color is already shown automatically via the variant's own Color
      // option (item.options_with_values in the cart template) — repeating
      // it here as a custom property would just show it twice in the cart
      const properties = {
        'Print Method': PRINT_METHODS.find(m=>m.key===state.method).label,
      };
      // The cart templates use the first property whose name contains "Design"
      // as the line's thumbnail, so the mockups go first and nothing else may
      // use that word in its name.
      results.forEach((r, i)=>{
        properties[`_Design – ${r.loc.label}`] = mockupUrls[i];
      });
      results.forEach((r, i)=>{
        properties[`_Print file – ${r.loc.label}`] = printUrls[i];
      });
      originalUrls.forEach((url, i)=>{
        properties[`_Original upload ${i + 1}`] = url;
      });

      footer.innerHTML = '<span class="preview-status">Adding to cart…</span>';

      // charge for what the price summary actually shows: the blank garment,
      // plus one "Extra Print" add-on line per designed location (every
      // location is charged — there's no free first print/embroidery)
      const prints = designedLocationsCount();
      const items = [{ id: variant.id, quantity: 1, properties }];
      if(prints > 0){
        items.push({
          id: ADDON_VARIANTS.extraPrint[state.method],
          quantity: prints,
          properties: { _For: prints + ' ' + state.method + ' location(s) — ' + currentColor().name + ', size ' + state.size },
        });
      }

      return fetch((window.routes && window.routes.cart_add_url) || '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items }),
      });
    })
    .then(r=>r.json())
    .then((res)=>{
      if(res.status){ // Shopify returns an error object with a `status` field on failure
        throw new Error(res.description || res.message || 'Could not add to cart');
      }
      refreshCartCount();
      showPreviewSuccess(results);
    })
    .catch((err)=>{
      console.error(err);
      footer.innerHTML = `
        <span class="preview-status preview-error">Something went wrong — please try again.</span>
        <button type="button" class="preview-btn-primary" id="previewRetryBtn">Retry</button>
      `;
      document.getElementById('previewRetryBtn').addEventListener('click', ()=> confirmAddToCart(results, variant));
    });
}

function showPreviewSuccess(results){
  document.getElementById('previewModalBody').innerHTML = `
    <div class="preview-success">
      <div class="preview-success-icon">✅</div>
      <div class="preview-success-text">Added to your cart!</div>
      <img src="${results[0].dataUrl}" alt="Added design preview" class="preview-success-img">
    </div>
  `;
  document.getElementById('previewModalFooter').innerHTML = `
    <button type="button" class="preview-btn-secondary" id="previewContinueBtn">Continue Customizing</button>
    <a href="/cart" class="preview-btn-primary" id="previewViewCartBtn">View Cart</a>
  `;
  document.getElementById('previewContinueBtn').addEventListener('click', closePreviewModal);
}

function closePreviewModal(){
  document.getElementById('previewModal').hidden = true;
}

/* keeps the theme's own header cart bubble (Dawn: .cart-count-bubble) in
   sync after a successful add, without depending on its internal drawer API */
function refreshCartCount(){
  fetch('/cart.js')
    .then(r=>r.json())
    .then(cart=>{
      document.querySelectorAll('.cart-count-bubble span[aria-hidden="true"]').forEach(el=>{
        el.textContent = cart.item_count;
      });
    })
    .catch(()=>{});
}

function showToast(msg){
  const el = document.getElementById('toast');
  el.textContent = msg;
  el.classList.add('show');
  setTimeout(()=>el.classList.remove('show'), 2500);
}

/* ---------------------------------------------------------
   INIT
--------------------------------------------------------- */
function init(){
  renderProductGroup();
  renderColorGroup();
  renderSizeGroup();
  renderMethodGroup();
  updateStagePhoto();
  renderViewThumbs();
  renderMiniThumbs();
  renderLocButtons();
  initCanvas();
  layoutCanvas();
  bindEvents();
  updatePrice();
  renderAssetGallery();
  loadProductData();
}
init();
